/*
  Turns Dawn's single mobile "Filter and sort" drawer into two bottom sheets
  driven by one fixed bar: SORT BY on the left, FILTER on the right.

  Both sheets share Dawn's `#FacetFiltersFormMobile` form on purpose. Its AJAX
  serialises that one form (facets.js `onSubmitHandler`), so splitting the
  controls into two real forms would make each sheet drop the other's
  parameters. Only the presentation is split: a `data-facet-mode` attribute on
  the <details> decides which sheet is on screen.

  MenuDrawer already binds a click handler to the same <summary>. This listens
  in the capture phase so it can switch modes without MenuDrawer toggling the
  drawer shut underneath.
*/
class FacetSheets extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details.mobile-facets__disclosure');
    this.summary = this.details && this.details.querySelector('summary');
    if (!this.details || !this.summary) return;

    if (!this.details.hasAttribute('data-facet-mode')) {
      this.details.setAttribute('data-facet-mode', 'filter');
    }

    // Capture phase: runs before MenuDrawer's own summary handler.
    this.summary.addEventListener('click', this.onSummaryClick.bind(this), true);
  }

  onSummaryClick(event) {
    const button = event.target.closest('[data-facet-mode]');
    if (!button) return;

    const mode = button.dataset.facetMode;
    const isOpen = this.details.hasAttribute('open');
    const currentMode = this.details.getAttribute('data-facet-mode');

    // Switching sheets while one is already open should swap the contents,
    // not close the drawer.
    if (isOpen && mode !== currentMode) {
      event.preventDefault();
      event.stopPropagation();
      this.details.setAttribute('data-facet-mode', mode);
      return;
    }

    this.details.setAttribute('data-facet-mode', mode);
  }
}

if (!customElements.get('facet-sheets')) {
  customElements.define('facet-sheets', FacetSheets);
}
